import { useState, useRef, useEffect } from "react"
import { Input, Typography, Flex, Alert } from "antd"
import CustomButton from "../../components/CustomButton/Button";
import { BTN_TXT, DESC_TXT } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { registerValidateOtp, registerSendOtp } from "../../redux/slices/AuthSlice";

const { Title, Text } = Typography;

const numberOfDigits = 6;

const OtpVerification = ({ contactType, contactValue, setOtpModalOpen, setIsVerified }) => {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
    const [seconds, setSeconds] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const otpBoxReference = useRef([]);
    const isOtpFilled = otp.every((digit) => digit !== "");
    const { otpError, validateLoading, otpData } = useSelector((state) => state.auth);

    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(timerId);
        } else {
            setIsResendEnabled(true);
        }
    }, [seconds]);

    const handleChange = (value, index) => {
        let newArr = [...otp];
        newArr[index] = value;
        setOtp(newArr);

        if (value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleBackspaceAndEnter = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            otpBoxReference.current[index - 1].focus();
        }
        if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleResendOtp = async () => {
        const payload = {
            email: contactValue,
            mobile: contactValue,
        }
        if (contactType === "email") {
            delete payload.mobile;
        } else {
            delete payload.email;
        }
        await dispatch(
            registerSendOtp(payload)
        );
        setOtp(new Array(numberOfDigits).fill(""));
        setSeconds(60);
        setIsResendEnabled(false);

    };

    const handleVerifyOtp = async () => {
        const otpString = otp.join("");

        const payload = {
            email: contactValue,
            mobile: contactValue,
            otp: otpString,
            reqId: otpData?.reqId,
        }

        if (contactType === "email") {
            delete payload.mobile
        } else {
            delete payload.email
        }

        const response = await dispatch(registerValidateOtp(payload))

        if (response.payload.statusCode === 201) {
            setOtp(new Array(numberOfDigits).fill(""));
            setIsVerified(prev => ({
                ...prev,
                [contactType]: true
            }));
            setOtpModalOpen(false);
        }

    }

    return (
        <div style={{ padding: 20 }}>
            <Title level={3}>Verify OTP</Title>
            <Text style={{ fontSize: 14, textAlign: "center" }}>
                {`We have sent a 6-digit OTP to ${contactValue}`}
            </Text>
            <Flex
                align="center"
                justify="space-between"
                style={{ marginTop: 20, width: "100%" }}
            >
                {otp.map((digit, index) => (
                    <Input
                        key={index}
                        value={digit}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                        ref={(reference) => (otpBoxReference.current[index] = reference)}
                        style={{ textAlign: "center", width: 50.6 }}
                        maxLength={1}
                    />
                ))}
            </Flex>

            <CustomButton
                type="link"
                onClick={handleResendOtp}
                disabled={!isResendEnabled}
                style={{ marginTop: 20, padding: 0 }}
            >
                {BTN_TXT.RESEND_OTP}
            </CustomButton>

            {otpError && <Alert style={{ marginTop: 20 }} message={otpError} type="error" showIcon />}

            <CustomButton
                type="primary"
                block
                onClick={handleVerifyOtp}
                disabled={!isOtpFilled}
                loading={validateLoading}
                style={{ marginTop: 20 }}
            >
                {BTN_TXT.VERIFY_OTP}
            </CustomButton>

            {!isResendEnabled && (
                <Text style={{ display: "block", marginTop: 10, textAlign: "center" }}>
                    Resend in {seconds} {seconds === 1 ? "second" : "seconds"}
                </Text>
            )}

            {contactType === "email" && (
                <Text style={{ color: "#40566D", marginTop: 20, fontSize: 12, textAlign: "center", display: "block" }}>
                    {DESC_TXT.OTP_INFO_TEXT}
                </Text>
            )}

        </div>
    )
}

export default OtpVerification